import React from 'react';
import { makeStyles } from '@mui/styles';
import { Avatar, Grid, Theme, Tooltip } from '@mui/material';
import {
  TaskAltOutlined,
  MailOutlined,
  EventOutlined,
  PendingOutlined,
} from '@mui/icons-material';
import { NoMaxWidthTooltip } from '../NoMaxWidthTooltip';
import { ResponseDueIcon, SchedulingIcon } from '../../components/icons';
export type IconType =
  | 'task'
  | 'event'
  | 'coordination'
  | 'resp_due'
  | 'schedule';
export type IconCircleProps = {
  icons: IconType[];
  calendar?: boolean;
  active?: boolean;
};

export const IconCircle = ({
  icons = [],
  calendar = false,
  active = false,
}: IconCircleProps) => {
  const numIcons = icons?.length;
  const classes = makeStyles((theme: Theme) => ({
    avatar: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      backgroundColor: 'transparent',
      color: 'inherit',
      overflow: 'visible',
      border: active ? `1px solid ${theme.palette.secondary.main}` : undefined,
    },
    icon: {
      fontSize: numIcons === 1 ? undefined : '15px',
    },
  }))();
  let tooltip: string[] = calendar ? [] : ['ITEM INCLUDES:'];
  if (icons.includes('task')) {
    if (calendar) {
      tooltip.push('ITEM DUE DATE');
    } else {
      tooltip.push('Task');
    }
  }
  if (icons.includes('resp_due')) {
    if (calendar) {
      tooltip.push('MESSAGE RESPONSE DUE');
    }
  }
  if (icons.includes('coordination')) {
    if (calendar) {
      tooltip.push('SCHEDULING DUE BY');
    } else {
      tooltip.push('Messaging');
    }
  }
  if (icons.includes('event')) {
    if (calendar) {
      tooltip.push('INSTALL EVENT DATE(S)');
    } else {
      tooltip.push('Event');
    }
  }
  tooltip = [];
  if (numIcons === 1) {
    if (icons.includes('task')) {
      return (
        <Tooltip title="General Task">
          <Avatar className={classes.avatar}>
            <Grid container justifyContent="center" spacing={0.1}>
              <TaskAltOutlined fontSize="small" className={classes.icon} />
            </Grid>
          </Avatar>
        </Tooltip>
      );
    } else if (icons.includes('schedule')) {
      return (
        <Tooltip title="Scheduling Due">
          <Avatar className={classes.avatar}>
            <Grid container justifyContent="center" spacing={0.1}>
              <SchedulingIcon className={classes.icon} />{' '}
            </Grid>
          </Avatar>
        </Tooltip>
      );
    } else if (icons.includes('event')) {
      return (
        <Tooltip title="Event">
          <Avatar className={classes.avatar}>
            <Grid container justifyContent="center" spacing={0.1}>
              <EventOutlined fontSize="small" className={classes.icon} />{' '}
            </Grid>
          </Avatar>
        </Tooltip>
      );
    } else if (icons.includes('coordination')) {
      return (
        <Tooltip title="Messaging">
          <Avatar className={classes.avatar}>
            <Grid container justifyContent="center" spacing={0.1}>
              <MailOutlined fontSize="small" className={classes.icon} />{' '}
            </Grid>
          </Avatar>
        </Tooltip>
      );
    } else if (icons.includes('resp_due')) {
      return (
        <Tooltip title="Message Response Due">
          <Avatar className={classes.avatar}>
            <Grid container justifyContent="center" spacing={0.1}>
              <ResponseDueIcon className={classes.icon} />{' '}
            </Grid>
          </Avatar>
        </Tooltip>
      );
    } else {
      return (
        <Avatar className={classes.avatar}>
          <Grid container justifyContent="center" spacing={0.1}>
            <div />{' '}
          </Grid>
        </Avatar>
      );
    }
  } else {
    return (
      <NoMaxWidthTooltip title={tooltip.length > 0 ? tooltip.join('\r\n') : ''}>
        <Avatar className={classes.avatar}>
          <Grid container justifyContent="center" spacing={0.1}>
            {icons.includes('task') && (
              <Grid item key={'t'} sx={{ p: 0 }}>
                <TaskAltOutlined fontSize="small" className={classes.icon} />
              </Grid>
            )}
            {icons.includes('schedule') && (
              <Grid item key={'t'} sx={{ p: 0 }}>
                <SchedulingIcon className={classes.icon} />
              </Grid>
            )}
            {icons.includes('event') && (
              <Grid item key={'e'} sx={{ p: 0 }}>
                <EventOutlined fontSize="small" className={classes.icon} />
              </Grid>
            )}
            {icons.includes('coordination') && (
              <Grid item key={'c'} sx={{ p: 0 }}>
                <MailOutlined
                  fontSize="small"
                  className={classes.icon}
                  sx={{ pt: numIcons === 1 ? undefined : '2.3px' }}
                />
              </Grid>
            )}
            {icons.includes('resp_due') && (
              <Grid item key={'t'} sx={{ p: 0 }}>
                <ResponseDueIcon className={classes.icon} />
              </Grid>
            )}
          </Grid>
        </Avatar>
      </NoMaxWidthTooltip>
    );
  }
};
